<template>
  <div id="app" :class="animotion?'fixed':''">
      <!--未关注-->
      <div class="top-prompt" @click="showQRcode" v-show="is_subscribe == 0">
          <i class="pull-left ionicons ion-ios-information mr10"></i>
          <template v-if="!is_vietnam">
                <span class="pull-left">您还没关注公众号，快来关注我吧！</span>
                <button>关注</button>
          </template>
          <template v-else>
                <span class="pull-left">Bạn không quan tâm đến công chúng, hãy đến và theo dõi tôi!</span>
                <button>Sự quan tâm</button>
          </template>
      </div>
      <router-view :class="{'none-subscribe': is_subscribe == 0}" :foot_type="foot_type" :is_wifi="is_wifi"></router-view>
      <!-- <div class="app-foot-nav clearfix" v-if="foot_type !== null">
          <div :class="{'active': foot_type == 0}" @click="toUrl('/',{usertest:25})">
              <p class="f20 icon-wrap">
                  <i class="iconfont icon-index"></i>
              </p>
              <p class="f12">首页</p>
          </div>
          <div :class="{'active': foot_type == 4}" @click="toUrl('/personal/index',{usertest:25})">
              <p class="f20 icon-wrap">
                  <i class="iconfont icon-personal"></i>
              </p>
              <p class="f12">我的</p>
          </div>
      </div> -->


      <!--弹出关注二维码-->
      <div class="wrap" v-if="wrap" @touchmove.prevent>
          <div class="QR-code">
              <i class="close ionicons ion-ios-close-outline"  @click="showQRcode"></i>
              <h1><span>生命说商城</span></h1>
              <div>
                <img :src="img_path" alt="">
              </div>
              
              <p>长按二维码，关注我们</p>
          </div>
      </div>

    <!-- 右边悬浮 -->
    <div i="navigation" 
        class="h-navi" 
        ref="kefu"
        v-if="showkefu"
        :style="[{'bottom': bottomValue + 'px'}, {'right': rightValue + 'px'}]"
        @touchmove="touchmove"
        @touchstart="touchstart"
        @touchend="touchend">
        <!-- <a class="h-cart m-size" @click="toUrl('/retail/cart')"></a> -->
        <a class="h-service m-size" v-if="!is_vietnam" @click="toKefu()"></a>
        <a class="h-service m-size" v-if="is_vietnam" style="background-image: url(/static/images/vietnam/hover_service@3x.png);" @click="toKefu()"></a>
        <!-- <a class="h-center m-size" v-if="is_dealer == 0" @click="toUrl('/retail/personal/index')"></a>
        <a class="h-center m-size" v-else @click="toUrl('/distribution/personal/index')"></a> -->
    </div>
      <!-- <div i="navigation" hidden>
          <div class="navigation" id="navigation">
              <ul class="nav-one" i="nav-one">
                  <ul class="nav-dn" i="sty" ref="sty">
                      <li i="sty" v-if="is_dealer == 1" @click="toUrl('/distribution/index')">
                          <a class="db">
                              <img src="/static/images/navigation_06.png">
                          </a>
                      </li>
                      <li i="sty" v-else @click="toUrl('/')">
                          <a class="db">
                              <img src="/static/images/navigation_06.png">
                          </a>
                      </li>
                      <li i="sty" v-if="is_dealer == 1" @click="toUrl('/distribution/personal/index')">
                          <a class="db">
                              <img src="/static/images/navigation_03.png">
                          </a>
                      </li>
                      <li i="sty" v-else @click="toUrl('/retail/personal/index')">
                          <a class="db">
                              <img src="/static/images/navigation_03.png">
                          </a>
                      </li>
                  </ul>
                  <li i="openWrap" ref="openWrap">
                      <img src="/static/images/navigation_01.png">
                  </li>
              </ul>
          </div>
      </div> -->
        <!-- <div class="kefu-float" @click="toKefu()" hidden>
            <img src="/static/images/kefu1.png">
        </div> -->


    <!--弹窗-->
    <div class="base-props-box" v-show="show_alert">
        <!-- <div class="props-box"> -->
        <div class="props" @touchmove.prevent>
        </div>
        <div class="alert-a" @touchmove.prevent>
            <div class="middle-center">
                <p class="text-center">温馨提示</p>
                <p>检测到您还未完善实名信息，为了更好的为您提供更多服务，请移步完善！</p>
                <div class="div-btns clearfix">
                    <a class="pull-left" @click="show_alert = false">下次再说</a>
                    <a class="pull-right" @click="toInfo()">前往完善</a>
                </div>
            </div>
        </div>
    </div>
    <!--弹窗-->
    <div class="base-props-box" v-show="show_prop">
        <div class="props"></div>
        <div class="alert-a">
            <div class="middle-center">
                <p class="text-center">温馨提示</p>
                <p>此常住地无需与身份证地址相同，请选择您从事商业活动和日常生活所在地，如有变更，可在个人设置中修改</p>
                <div class="div-btns clearfix">
                    <a class="pull-right" @click="toAddress()">前往设置</a>
                </div>
            </div>
        </div>
    </div>

    <!--弹窗-->
    <div class="base-props-box" v-show="show_esign">
        <div class="props"></div>
        <div class="alert-a">
            <div class="middle-center">
                <p class="text-center">温馨提示</p>
                <p>恭喜您成为生命说加盟商，为了保护您的权益，快去签署《加盟商合同》吧！</p>
                <div class="div-btns clearfix">
                    <a class="pull-right" @click="toUrl('/contract/index')">去签署</a>
                </div>
            </div>
        </div>
    </div>
    <!-- 绑定推荐人弹窗 -->
    <div class="alert-box" v-show="bind_superior">
        <div class="alert-mk"></div>
        <div class="alert-cont">
            <div class="cont-title">提醒信息</div>
            <div class="cont-img"></div>
            <div class="cont-phone">绑定推荐人，可享更多服务</div>
            <div class="alert-btn-group">
                <div class="alert-btn-cancel" @click="bind_superior = false">稍候绑定</div>
                <div class="alert-btn-confirm" @click="handelBindSuperior">立即绑定</div>
            </div>
        </div>
    </div>
    <!-- 首页广告 -->
    <div class="middle-eject" v-if="advertise.lists.length">
        <div class="back"></div>
        <div class="advertise">
            <div class="close-adver" @click.stop="changeBack()">跳过</div>
            <div class="adver-content" :style="`background-image:url(${advertise.back.cover});`" @click="goOutsideUrl(advertise.back)"></div>
        </div>
    </div>

    <!-- 到期提醒弹窗 -->
    <div class="remind-box" v-if="giftGoods.length>0">
        <div class="mask"></div>
        <div class="content">
             <div class="del-icon"  @click="giftGoods=[]"></div>
             <div class="remind-title">赠品到期提醒</div>
            <div class="remind-desc">以下云仓中赠品请尽快自提，超时未自提将自动扣除：</div>
            <div class="goods-box">
                <div class="goods-item" v-for="(item,index) in giftGoods" :key="index">
                    <div class="goods">
                        <div class="cover" :style="{'background-image':'url('+item.cover+')'}"></div>
                        <div class="info">
                            <div class="goods-name">{{item.goods_name}}</div>
                            <div>
                                <div class="num">x {{item.gift_num}}</div>
                                <div class="date">失效时间:{{item.expires_time}}</div>
                            </div>
                            
                        </div>
                    </div>
                    <!-- <div class="date">失效时间:{{item.expires_time}}</div> -->
                </div>
            </div>
            <div class="remind-btn"  @click="giftGoods=[];toUrl('/distribution/dispatch/index')">立即自提</div>
        </div>
    </div>
    
    <!-- 快捷导航 -->
        <!-- <div class="shortcut" v-if="shortcut">
            <div :class="animotion?'mask':''" @click="cutNav"></div>
            <div class="navbox" :class="animotion?'animotion':''">
                <div class="icon"></div>
                <div class="nav" @click="cutNav">快捷导航</div>
                <div class="nav-box" :class="boxActive == 1?'box-active' :''" @click="tabActive(1)">我的</div>
                <div class="nav-box" :class="boxActive == 2?'box-active' :''" @click="tabActive(2)">首页</div>
            </div>
        </div> -->

  </div>
</template>

<script>

export default {
    data() {
        return {
            foot_type: null,
            wrap: false,  /*显示关注二维码*/
            is_subscribe: 1,
            is_dealer: 0,
            img_path: '',
            is_trditional: false,
            is_init: true,
            is_wxjs: true,       //是否选择默认微信配置
            kefu: {
                type: 0,  //标识商品或订单(1商品，2订单。。。)
                id: 0     //对应的商品id或订单id
            },
            show_alert: false,
            showkefu:false,
            show_esign:false,
            areaShow: false,
            nationCode: {},
            city: [],
            show_prop: false,

            is_vietnam: tools.cache.get('is_vietnam'),

            animotion: false,
            boxActive: 1,
            shortcut:false,
            is_wifi: false,

            advertise:{
                lists:[],
                back:{},
                index:0
            },
            bottomValue: 73,
            rightValue: 12,
            touchStart: '',
            touchEnd: '',
            kfHeight: '',
            kfWidth: '',
            bind_superior: false,
            giftGoods:[]
        }
    },
    created() {
        let that = this;
        //   if(tools.cache.get('is_traditional') == 1){
        //     var style1 = document.createElement('style');
        //     style1.innerHTML = "@font-face {font-family: 'big5';src: url('"+ location.origin +"/static/font/big5.ttf');}";
        //     document.head.appendChild(style1);
        //   }
        tools.cache.del('isShowpassword')
        window.HubBus = new tools.vue();
        window.HubBus.$on('footType', function (type) {
            that.foot_type = type;
        });
        window.HubBus.$on('popup', function (type) {
            that.show_alert = type;
        });
        // 绑定推荐人弹窗
        window.HubBus.$on('bindSuperior', function (type) {
            that.bind_superior = type;
        });
        window.HubBus.$on('title', function (text) {
            document.title = text;
        });
        window.HubBus.$on('wxConfig', function (type) {
            that.is_wxjs = type;
        });
        window.HubBus.$on('setKefu', function (obj) {
            if (!obj) {
                //离开页面后再次触发,不传参数,清除数据
                that.kefu = {
                    type: 0,
                    id: 0
                };
            } else {
                that.kefu = obj;
            }
        });
        tools.router.afterEach((to, from, next) => {
            if (this.is_init) {
                this.is_init = false;
                //   服务器迁移停机维护
                that.isLogin('/api/islogins');
            }
            if (to.path=="/distribution/index"&&!tools.cache.get('startIndexData')) {
                that.isLogin('/api/islogins');
            }
            //全局悬浮恢复默认样式
            //   setTimeout(function(){
            //       that.$refs.sty.setAttribute('class','nav-dn');
            //       let arr = that.$refs.sty.children || [];
            //       for(let i = 0; i < arr.length; i++){
            //           arr[i].setAttribute('class','db');
            //       }
            //     }, 0);
            //如果是ios
            /*if(app.device().ios && app.isWeChat() && tools.cache.get('originUrl')){
                app.wechatjs.setShareUrl(tools.cache.get('originUrl'));
                //app.wechatjs.share_config.share_url = tools.cache.get('originUrl');
                app.wechatjs.ready();  
            }*/
        });

        /*
            **混合 （请认真查看使用方法 https://vuefe.cn/v2/guide/mixins.html）
            **注意同名钩子函数将混合为一个数组，因此都将被调用。且先调用混合对象的钩子
            **
        */
        tools.vue.mixin({
            data() {
                return {
                    level_id: 0, // 类型
                }
            },

            mounted() {
                let loginData = tools.cache.get('loginData')?JSON.parse(tools.cache.get('loginData')):{};
                this.level_id = loginData.level_id;
            },

            /* 全局方法 */
            methods: {
                /* 默认图片过滤 */
                thumbnail: function (val, size) {
                    let img_size = '?x-oss-process=image/resize,w_' + size;
                    return !val ? app.defaultImg() : val + (!size ? '' : img_size);
                },

                toThumbnail: function (val, size) {
                    let img_size = '?x-oss-process=image/resize,w_' + size;
                    return !val ? '' : val + (!size ? '' : img_size);
                },

                /* 查看大图 */
                seeImg: function (imgUrl, arr) {
                    let imgArr = arr;
                    if (arr === undefined) {
                        imgArr = [imgUrl];
                    }
                    app.seeImg(imgUrl, imgArr);
                },
                /* 跳转 */
                toUrl: function (url, val) {
                    tools.router.push({ path: url, query: val });
                },
                /* 跳转 */
                toReplace: function (url, val) {
                    tools.router.replace({ path: url, query: val });
                },
                goAuth(callback,type){
                    var callback = callback || function(){};
                    tools.cache.set('is_wechat_login',1);
                    tools.loginStatus.check({
                        is_pay:type || false,
                        type: 'wechatOauth', // wechatOauth, login
                        redirectUrl: '/api/wechat/auth', //验证不通过跳转的地址
                        url: that.$route.path, //需要验证的地址
                        callbackUrl: that.$route.fullPath //返回的地址
                    },callback);
                }
            },
            /* 全局过滤 */
            filters: {
                /* 默认图片过滤 */
                thumbnail: function (val, size) {
                    return !val ? app.defaultImg() : val + (!size ? '' : size);
                },

                /* 时间转换 */
                timeTran: function (value) {
                    return !value ? '-' : tools.date('Y-m-d H:i:s', value);
                },

                /* 自定时间格式转换 */
                setTimeTran: function (value, type) {
                    return parseInt(value) === 0 ? '-' : tools.date(type, value);
                },

                /* 价格转换--保留两位小数 */
                toFixedPrice: function (value) {
                    return value ? (parseInt(value) / 100).toFixed(2) : '0';
                },

                //价格转换(保留两位小数,不足补零,大数字3位数加一个逗号)
                priceFormat: function (val) { //val是以分为单位
                    if (typeof val === 'undefined') {
                        return;
                    }
                    var val_str = '',
                        val_arr = [];
                    val_str = val.toString();
                    val_arr = val_str.split('');
                    //判断价格位数
                    if (val_arr.length <= 5) {
                        return (val / 100).toFixed(2);
                    } else {
                        val_arr.splice(val_arr.length - 2, 0, '.'); //添加小数点
                        for (var i = val_arr.length - 4, num = 1; i > 0; i-- , num++) {
                            if (num == 3) {
                                val_arr.splice(i, 0, ','); //添加逗号
                                num = 1;
                                i--;
                            }
                        }
                        return val_arr.join('');
                    }
                },

                /* 价格转换 */
                toPrice: function (value) {
                    return value ? (parseInt(value) / 100) : '0';
                },
                f_status: function (status) {
                    let txt = '';
                    let is_vietnam = tools.cache.get('is_vietnam');
                    switch (Number(status)) {
                        case -1: txt = is_vietnam ? 'Toàn bộ trạng thái' : '全部状态'; break;
                        case 0: txt = is_vietnam ? 'Chờ thanh toán' : '待付款'; break;
                        case 1: txt = is_vietnam ? 'Chờ giao hàng' : '待发货'; break;
                        case 2: txt = is_vietnam ? 'Chờ nhận hàng' : '待收货'; break;
                        case 3: txt = is_vietnam ? 'Đã hoàn thành' : '已完成'; break;
                        case 4: txt = is_vietnam ? 'Sau bán hàng' : '售后中'; break;
                        case 5: txt = is_vietnam ? 'Đã đóng' : '已关闭'; break;
                        case 6: txt = is_vietnam ? 'Hoàn thành sau bán hàng' : '售后完成'; break;
                        case 7: txt = is_vietnam ? 'Đã hủy' : '已取消'; break;
                        case 8: txt = is_vietnam ? 'Chờ xét duyệt' : '待审核'; break;
                        case 9: txt = is_vietnam ? 'Xét duyệt thất bại' : '审核失败'; break;
                        case 10: txt = is_vietnam ? 'Chờ điền phí vận chuyển' : '待填运费'; break;
                    }
                    return txt;
                },
                levelName: function (val) {
                    let txt = '';
                    switch (val) {
                        case 1: txt = 'E'; break;
                        case 2: txt = 'D'; break;
                        case 3: txt = 'C'; break;
                        case 4: txt = 'B'; break;
                        case 5: txt = 'A'; break;
                    }
                    return txt;
                }
            }
        });

    },
    name: 'app',
    watch: {
        // 如果路由有变化，会再次执行该方法
        '$route': 'isLinkChange'
    },
    methods: {
        // 跳转绑定推荐人
        handelBindSuperior() {
            this.bind_superior = false;
            this.toUrl('/binding/bindsuperior', {callbackUrl: this.$route.fullPath});
        },
        touchstart(e) {
            let that = this;
            if (e.changedTouches.length > 1) {
                return false;
            }
            that.touchStart = e.changedTouches[0];
            that.kfHeight = that.$refs.kefu.offsetHeight;
            that.kfWidth = that.$refs.kefu.offsetWidth;
        },
        touchmove(e) {
            e.preventDefault();
        },
        touchend(e) {
            let that = this;
            that.touchEnd = e.changedTouches[0];
            if (that.touchEnd.clientY - that.touchStart.clientY < 0) {
                that.bottomValue += (that.touchEnd.clientY - that.touchStart.clientY) * -1;
                if (that.bottomValue > window.screen.availHeight - that.kfHeight) {
                    that.bottomValue = window.screen.availHeight - that.kfHeight;
                }
            } else {
                that.bottomValue -= (that.touchEnd.clientY - that.touchStart.clientY);
                if (that.bottomValue < 50) {
                    that.bottomValue = 50;
                }
            }
            if (that.touchEnd.clientX - that.touchStart.clientX < 0) {
                that.rightValue += (that.touchEnd.clientX - that.touchStart.clientX) * -1;
                if (that.rightValue > window.screen.availWidth - that.kfWidth) {
                    that.rightValue = window.screen.availWidth - that.kfWidth;
                }
            } else {
                that.rightValue -= (that.touchEnd.clientX - that.touchStart.clientX);
                if (that.rightValue < 0) {
                    that.rightValue = 0;
                }
            }
        },
        urlChange(){
            let that = this;
            let isLogin = tools.cache.get('isLogin');
            if(isLogin == 1){
                that.shortcut = true;
            }
            if(that.$route.path == '/distribution/index'){
                that.boxActive = 2
            }else if(that.$route.path == '/distribution/personal/index'){
                that.boxActive = 1
            }else{
                 that.boxActive = 0
            }

            // 判断是否该显示弹窗
            var loginData = tools.cache.get('loginData')?JSON.parse(tools.cache.get('loginData')):{};
            // console.log(that.$route.path.indexOf('/contract')<0);
            if ((loginData.level_id==5&&loginData.is_sign==0)&&that.$route.path.indexOf('/contract')<0) {
                that.show_esign = true;
            }else{
                that.show_esign = false;
            }
        },
        tabActive(index) {
            this.boxActive = index;
            this.animotion = !this.animotion;
            if (index == 1) {
                this.toUrl('/distribution/personal/index')
            }else if(index == 2){
                this.toUrl('/distribution/index')
            }
        },
        cutNav() {
            this.animotion = !this.animotion;
        },
        toInfo() {
            this.show_alert = false;
            this.toUrl('/distribution/improveidentity')
        },
        toAddress() {
            this.show_prop = false;
            this.toUrl('/address')
        },
        showLoading: function () {
            var that = this;

            console.log('改变了导航:', this.$route);
            that.is_dealer = tools.cache.get('isDealer');
            //   that.is_subscribe = Number(tools.cache.get('isSubscribe'));
            that.is_subscribe = 1;
            that.img_path = tools.cache.get('mpQrcode');
            //tools.alert.closeLoading();
        },
        showQRcode: function () {
            var _this = this;
            _this.wrap = !_this.wrap
        },
        toKefu: function () {
            var that = this;
            if (that.kefu.type == 1) {
                that.toUrl('/distribution/chat', { goods_id: that.kefu.id });
            } else if (that.kefu.type == 2) {
                that.toUrl('/distribution/chat', { order_id: that.kefu.id });
            } else {
                that.toUrl('/distribution/chat');
            }
        },
        isShowPopup(to) {
            let that = this;
            let loginData = tools.cache.get('loginData');
            if (loginData) {
                let data = JSON.parse(loginData);
                if (data.level_id > 2 && data.is_perfect != 1 && to.path !== '/distribution/improveidentity' && to.path !== '/login' && to.path !== '/register') {
                    that.show_alert = true;
                }
            }
        },
        isLinkChange: function (to) {
            let that = this;
            that.urlChange();
            // console.log('改变了导航:',this.$route);
            if ((this.$route.path=='/update'||this.$route.path=='/register')
                || this.$route.path=='/goods_promote'
                ||(this.$route.path=='/distribution/goodscomb'&&tools.url.params('share_from')>0)
                ||(this.$route.path=='/distribution/goodsdetail'&&tools.url.params('share_from')>0)
                ||tools.cache.get('isUser')==0
                || this.$route.path=='/distribution/help/index'
                || this.$route.path=='/distribution/exchange/index') {
                that.showkefu = false;
            }else{
                that.showkefu = true;
            }
            that.is_dealer = tools.cache.get('isDealer');
            // that.is_subscribe = tools.cache.get('isSubscribe');
            that.is_subscribe = 1;
            that.img_path = tools.cache.get('mpQrcode');
            that.is_vietnam = tools.cache.get('is_vietnam')
            // that.$refs.openWrap.removeAttribute('class');
            that.is_wxjs=true;
            //微信分享
            that.$nextTick(function () {
                // that.$refs.openWrap.removeAttribute('class');
                // that.$refs.sty.setAttribute('class','nav-dn');
                // let arr = that.$refs.sty.children || [];
                // for(let i = 0; i < arr.length; i++){
                //     arr[i].setAttribute('class','db');
                // }
                that.isShowPopup(to);
                setTimeout(function () {
                    //ios
                    if (app.device().ios && app.isWeChat() && that.is_wxjs) {
                        app.wechatjs.ready({
                            share_title: '生命说商城',
                            share_img: location.origin + '/static/images/mainproduct.jpg?123',
                            share_url: tools.cache.get('originUrl'),
                            share_desc: '全生命周期的健康管理',
                            is_specific: false
                            //share_title: document.title
                        });
                    }
                    //安卓
                    if (!app.device().ios && app.isWeChat() && that.is_wxjs) { //判断是否为微信
                        app.wechatjs.config = false;
                        app.wechatjs.share_config = {
                            share_title: '生命说商城',
                            share_img: location.origin + '/static/images/mainproduct.jpg?123',
                            share_url: location.href,
                            share_desc: '全生命周期的健康管理',
                            is_specific: false
                            //share_title: document.title
                        };
                        app.wechatjs.run({
                            api_url: '/api/wechat/js',
                            /*ajax_data: {
                                url: location.href
                            },
                            debug: true*/
                        })
                    }
                }, 500)
            })



            //that.foot_type = null;
        },
        /* 获取是否登录 */
        isLogin: function (url) {
            var that = this;
            log.debug('获取是否登录');
            //debugger
            tools.ajax({
                url: url,
                ajaxData: {},
                successFun: function (res) {
                    tools.cache.set('isUser', res.data.is_user);
                    tools.cache.set('isDealer', res.data.is_dealer);
                    localStorage.isDealer = res.data.is_dealer;

                    tools.cache.set('isSubscribe', res.data.is_subscribe);
                    tools.cache.set('mpQrcode', res.data.mp_qrcode);
                    tools.cache.set('parent', res.data.parent);

                    that.is_dealer = tools.cache.get('isDealer');
                    that.img_path = tools.cache.get('mpQrcode');
                    // that.is_subscribe = tools.cache.get('isSubscribe');
                    that.is_subscribe = 1;
                    that.show_prop = res.data.is_address === 0;
                    if (res.data.is_user==1&&(that.$route.path=='/'||that.$route.path=='/distribution/index')) {
                        that.getAdvertiseImg();
                        that.getGiftGoods();
                    }
                },
                errorFun: function (error) {
                    log.error('登录失败!');
                    tools.alert.error('登录失败!');
                    tools.cache.set('isLogin', 0);
                    tools.cache.set('isAuth', 0);
                },
                type: 'GET'
            });
        },
        /* 跳转 */
        toUrl: function (url, val) {
            tools.router.push({ path: url, query: val });
        },
        fun(res) {
            // console.log(res);
            this.nationCode = res;
        },
        // 首页广告
        getAdvertiseImg: function () {
            var that = this;
            tools.ajax({
                url: '/api/ads',
                ajaxData: {
                    module_type:2
                },
                successFun: function (res) {
                    if (res.list&&res.list.length) {
                        var data = JSON.parse(JSON.stringify(res.list)),
                            storageData=[],lists=[];

                        // 将不在条件内的广告先屏蔽
                        var startIndexData = tools.cache.get("startIndexData")?JSON.parse(tools.cache.get("startIndexData")):[];
                        for (let v = 0; v < data.length; v++) {
                            let arr = startIndexData.filter((item,index,array)=>{return item.id==data[v].id;});
                            if (arr&&arr.length) {
                                if ((arr[0].gap != data[v].gap || (arr[0].gap?arr[0].startTime*arr[0].gap*24*60*60*1000 <= (new Date().getTime()):false) )) {
                                    lists.push(data[v]);
                                }
                            } else {
                                lists.push(data[v]);
                            }
                        }
                        if (lists.length<=0) {
                            return false;
                        }
                        // 将展示的广告先保存
                        for (let i = 0; i < data.length; i++) {
                            storageData.push({
                                id: data[i].id,
                                gap: data[i].gap,
                                startTime: new Date().getTime()
                            })
                        }
                        tools.cache.set("startIndexData",JSON.stringify(storageData));
                        that.advertise.lists = lists;
                        that.advertise.back = that.advertise.lists[that.advertise.index];
                    }
                },
                errorFun: function (error) {
                },
                type: 'GET'
            });
        },

         // 到期提醒
        getGiftGoods: function () {
            var that = this;
            tools.ajax({
                url: '/api/gift/expire',
                successFun: function (res) {
                        console.log(res);
                        that.giftGoods=res.list;
                },
                errorFun: function (error) {
                },
                type: 'GET'
            });
        },
        //类型跳转 1app模块，2 url
        goOutsideUrl: function(data) {
            var that = this;
            that.advertise.lists=[];
            if (data.type==1) { //app模块
                switch (data.skip_type) {
                    case 1:	//商品详情
                        that.toUrl('/distribution/goodsdetail', {goods_id:data.skip_id});
                        break;
                    case 2: //学习中心
                        that.toUrl('/distribution/help/details', {id:data.skip_id});
                        break;
                    case 3:     //公告详情
                        that.toUrl('/retail/personal/message/details', {id:data.skip_id});
                        break;
                    case 4:     //组合商品
                        that.toUrl('/distribution/goodscomb', {goods_id:data.skip_id,is_comb:1});
                        break;
                    case 5:     //公告详情
                        that.toUrl('/distribution/material/details', {id:data.skip_id});
                        break;
                    case 6:     //活动日历详情
                        that.toUrl('/distribution/activity/details', {id:data.skip_id});
                        break;
                    case 7:     //零售商城首页
                        that.toUrl('/distribution/retail');
                        break;
                    case 8:     //订货首页
                        that.toUrl('/distribution/stock/list', {stock_status: 1});
                        break;
                    case 9:     //活动日历首页
                        that.toUrl('/distribution/activity/index');
                        break;
                    case 10:     //自营商城首页
                        that.toUrl('/distribution/retail',{isSelf:1})
                        break;
                }
            } else if(data.type==2){ //url外部链接
                if (!data.skip_url) {
                    return;
                }
                location.href = data.skip_url;
            }
        },
        changeBack(){
            var _this = this;
            if (_this.advertise.index>=_this.advertise.lists.length-1) {
                _this.advertise.lists=[];
                return;
            }
            _this.advertise.index++;
            _this.advertise.back = _this.advertise.lists[_this.advertise.index];
        }
    },
    mounted() {
        let that = this;
        that.$nextTick(function () {
            setTimeout(function () {
                //如果是ios
                if (app.device().ios && app.isWeChat() && that.is_wxjs) {
                    app.wechatjs.config = false;
                    //console.log(`APP mounted : ${tools.cache.get('initUrl')}`);             
                    app.wechatjs.share_config = {
                        share_title: '生命说商城',
                        share_img: location.origin + '/static/images/mainproduct.jpg?123',
                        share_url: tools.cache.get('initUrl'),
                        share_desc: '全生命周期的健康管理',
                        is_specific: false
                        //share_title: document.title
                    };
                    app.wechatjs.run({
                        api_url: '/api/wechat/js',
                        /*ajax_data: {
                            url:tools.cache.get('initUrl')
                        },
                        debug: true*/

                        
                    })
                    wx.getNetworkType({
                        success: function(res) {
                            // 判断当前是否wifi，不是Wi-Fi则不自动加载视频
                            console.log(111,res.networkType === 'wifi')
                            that.is_wifi = res.networkType === 'wifi';
                        }
                    })
                }
            }, 500);
        });
        //that.is_subscribe = 0;
    }
}
</script>

<style rel="stylesheet/scss" lang="scss">
@import "./assets/sass/tool.scss";

// 禁止页面移动
.fixed {
    position: fixed;
    width: 100%;
}
.middle-eject{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1001;
    align-items: center;
    .back {
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        position: absolute;
        z-index: 0;
        background: rgba(0, 0, 0, 0.5);
    }
    .advertise{
        position: absolute;
        background-color: #fff;
        border-radius: r(16px);
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        -webkit-transform: translate(-50%,-50%);
        overflow: hidden;
        .close-adver{
            position: absolute;
            color: rgba($color: #fff, $alpha: 0.8);
            font-size: r(24px);
            background-color: rgba(0, 0, 0, 0.5);
            height: r(50px);
            padding: 0 r(16px);
            border-radius: r(50px);
            top: r(20px);
            right: r(20px);
            z-index: 10;
            display: flex;
            align-items: center;
        }
        .adver-content{
            min-height: r(800px);
            width: r(600px);
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
        }
    }
}
.shortcut {
    .mask {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: #000;
        opacity: 0.5;
        z-index: 99;
    }
    .navbox {
        width: r(354px);
        height: r(90px);
        display: flex;
        justify-content: space-around;
        align-items: center;
        background-color: #fff;
        position: fixed;
        top: r(800px);
        right: r(-210px);
        // transform: translateY(-50%);
        border-radius: r(100px) 0px 0px r(100px);
        color: #4a4a4a;
        transition: all 1s ease;
        z-index: 999;
        box-shadow:0px 0px 10px 0px rgba(0,0,0,0.12);
        padding-left: r(16px);

        .icon {
            width: r(11px);
            height: r(26px);
            background-image: url("/static/images/stick.png");
            background-repeat: no-repeat;
            background-size: contain;
        }

        .nav {
            height: 100%;
            display: flex;
            align-items: center;
            // padding-left: r(10px);
        }

        .nav-box {
            width: r(92px);
            height: r(50px);
            line-height: r(50px);
            text-align: center;
            border-radius: r(27px);
        }
        .box-active {
            background-color: #185939;
            color: #fff;
        }
    }
    /*x轴平移*/
    .animotion {
        transform: translateX(r(-210px));
    }
}

.base-props-box {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    .props {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        // width: 100%;
        // height: 100%;
        background: #000000;
        opacity: 0.7;
        z-index: 101;
    }
    .alert-a {
        width: r(554px);
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        z-index: 101;

        .close-btn {
            text-align: center;
            margin-top: r(44px);
            font-size: r(70px);
            color: #ffffff;
        }
        .middle-center {
            position: relative;
            width: 100%;
            // height: pxTorem(676px/2);
            background-color: #fff;
            border-radius: r(15px);
            padding: r(30px);
            font-size: r(28px);
            p {
                margin-bottom: r(10px);
            }
            .div-btns {
                padding-top: r(10px);
                text-align: right;
                a {
                    margin-right: r(20px);
                    &:last-child {
                        color: rgb(54, 54, 233);
                    }
                }
            }
            // background-position: center;
            // background-size: cover;
            // padding-top: pxTorem(42px);
            .middel-top {
                width: r(403px);
                margin: 0 auto;
                text-align: center;
                font-size: r(34px);
                color: #60605f;
                letter-spacing: 0;
                padding-top: r(227px);
            }
            .middel-text {
                text-align: center;
                margin-top: r(45px);
                font-size: r(64px);
                color: #ff9d4a;
                letter-spacing: r(4.81px);
                span {
                    font-size: r(48px);
                }
            }
            .middel-bottom {
                width: r(470px);
                height: r(80px);
                text-align: center;
                line-height: r(84px);
                background: #ea9045;
                border-radius: r(8px);
                font-size: r(34px);
                color: #ffffff;
                letter-spacing: 0;
                position: absolute;
                bottom: r(42px);
                left: r(42px);
            }
        }
    }
}

.h-navi {
    width: pxTorem(50px);
    position: fixed;
    /* right: pxTorem(12px);
    bottom: pxTorem(73px); */
    z-index: 999;
    .m-size {
        background-repeat: no-repeat;
        background-size: cover;
        background-position: 0 0;
        display: block;
        clear: both;
        width: pxTorem(50px);
        height: pxTorem(50px);
        border-radius: pxTorem(5px);
        margin-bottom: pxTorem(10px);
        &:last-child {
            margin-bottom: 0;
        }
    }
    .h-cart {
        background-image: url("/static/images/hover_cart@3x.png");
    }
    .h-service {
        background-image: url("/static/images/hover_service2@3x.png");
    }
    .h-center {
        background-image: url("/static/images/hover_center@3x.png");
    }
}
#app {
    font-family: big5, PingFangSC-Regular, "Avenir", Helvetica, Arial,
        sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    // color: #fff;
    background-color: #fff;
    min-height: 100%;
}
.none-subscribe {
    padding-top: pxTorem(40px);
    &[i="distribution-personal-index"] {
        padding-top: pxTorem(40px) !important;
        .top {
            //   margin-top: pxTorem(40px)!important;
            //   height: pxTorem(300px);
        }
    }
    &[i="retail-personal-index"] {
        padding-top: pxTorem(40px) !important;
        .top {
            //   padding-top: pxTorem(55px);
            //   height: pxTorem(165px);
        }
    }
    &[i="distribution-stock-list"] {
        .fixed {
            //   top: pxTorem(40px);
            padding-top: pxTorem(40px);
        }
        // padding-top: pxTorem(95px);
    }
    &[i="distribution_register"] {
        padding-top: 0;
        .register {
            padding-top: pxTorem(55px);
            //height: pxTorem(165px);
        }
    }
    &[i="index"] {
        padding-top: pxTorem(40px) !important;
        .index-header {
            height: pxTorem(155px);
            padding-top: pxTorem(65px);
        }
    }
    &[i="loose-warp"] {
        padding-top: 0;
    }
}

.QR-code {
    width: pxTorem(295px);
    background: #fff;
    height: pxTorem(340px);
    border-radius: pxTorem(8px);
    position: relative;
    top: 50%;
    left: 50%;
    z-index: 100;
    text-align: center;
    margin-top: pxTorem(-170px);
    margin-left: pxTorem(-147.5px);

    h1 {
        color: #545454;
        font-size: pxTorem(14px);
        font-weight: normal;
        height: pxTorem(64px);
        line-height: pxTorem(64px);

        span {
            font-size: pxTorem(18px);
            font-weight: 600;
            color: #286acb;
            display: inline-block;
            margin-right: pxTorem(5px);
        }
    }
    img {
        width: pxTorem(215px);
        height: pxTorem(215px);
        margin: 0 auto;
    }
    p {
        font-size: pxTorem(18px);
        margin-top: pxTorem(20px);
        height: pxTorem(20px);
        line-height: pxTorem(20px);
        color: #9b9b9b;
    }
    i {
        position: absolute;
        height: pxTorem(40px);
        box-sizing: content-box;
        padding: pxTorem(10px) 0 0 pxTorem(10px);
        width: pxTorem(34px);
        font-size: pxTorem(34px);
        color: #9b9b9b;
        right: 0;
        top: pxTorem(-48px);
    }
}

.alert-box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    .alert-mk {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(54, 54, 54, 0.5);
        z-index: 100;
    }
    .alert-cont {
        position: relative;
        background: #FFFFFF;
        border-radius: r(10px);
        padding: r(53px) r(30px) r(40px);
        z-index: 101;
        text-align: center;
        .cont-title {
            font-size: r(32px);
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #333333;
            line-height: r(45px);
            margin-bottom: r(36px);
        }
        .cont-img {
            width: r(249px);
            height: r(162px);
            background-image: url('/static/images/login/isbindtjr.png');
            border-radius: 50%;
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
            margin: 0 auto r(43px);
        }
        .cont-phone {
            font-size: r(24px);
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: r(33px);
            margin-bottom: r(78px);
        }
        .alert-btn-group {
            display: flex;
            align-items: center;
            font-size: r(28px);
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            .alert-btn-cancel {
                width: r(239px);
                height: r(60px);
                border-radius: r(8px);
                border: r(2px) solid #1B8759;
                color: #1B8759;
                margin-right: r(22px);
                line-height: r(58px);
            }
            .alert-btn-confirm {
                width: r(239px);
                height: r(60px);
                border-radius: r(8px);
                background-color: #1B8759;
                color: #fff;
                line-height: r(60px);
            }
        }
    }
}
.remind-box{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    .mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(54, 54, 54, 0.5);
        z-index: 100;
    }
    .content{
        position: relative;
        background: #FFFFFF;
        border-radius: r(10px);
        padding: r(30px);
        z-index: 101;
        width: r(620px);
        .del-icon{
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: r(-100px);
            width: r(50px);
            height: r(50px);
            background-image: url("/static/images/close.png");
            background-position: center;
            background-repeat: no-repeat;
            background-size: contain;
        }
        .remind-title {
            font-size: r(30px);
            text-align: center;
            font-weight: 600;
        }
        .remind-desc{
            margin-top: r(20px);
            font-size: r(28px);
        }
        .goods-box{
            margin-top: r(20px);
            max-height: r(600px);
            overflow: auto;
            .goods-item{
                margin-bottom: r(24px);
                background-color: #F5F5F5;
                padding: r(20px) 0 r(20px) r(24px);
                border-radius: r(10px);
                .goods{
                    display: flex;
                    // align-items: center;
                    .cover{
                        width:r(152px);
                        height: r(152px);
                        background-position: center;
                        background-repeat: no-repeat;
                        background-size:cover;
                        border-radius: r(15px);
                    }
                    .info{
                        flex: 1;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        margin-left: r(20px);
                        font-size: r(24px);
                        .num{
                            margin-top: r(10px);
                        }
                    }
                }
                .date{
                    margin-top: r(10px);
                    color: #DC1C1C;
                    font-size: r(20px);
                }
            }
        }
        .remind-btn{
            display: flex;
            align-items: center;
            justify-content: center;
            width: r(400px);
            height: r(80px);
            background: linear-gradient(239deg, #82D7A9 0%, #2D9761 100%);
            margin: r(20px) auto 0;
            color: #fff;
            font-size: r(26px);
            border-radius: r(40px);
        }
    }
}
</style>



// WEBPACK FOOTER //
// App.vue?36c83cf3